import Project from "../components/Project";
import TravelBuddy from "../assets/images/project1.png";
import Dumbbells from "../assets/images/dumbells.png";
import EmployeeDirectory from "../assets/images/employeeDirectory.png";
import Weather from "../assets/images/weather.png";
import Budget from "../assets/images/budget.png";
import Burger from "../assets/images/eatBurger.png";
import "../assets/css/portfolio.css";

function Portfolio() {
    return (
        <div className="body">
            <main className="container">

                    <div className="page-header">
                        <h1 className="headingStyle">Portfolio</h1>
                        <hr className="headingLine" />
                    </div>

                <div className="row">

                    <div className="col">
                        <Project
                            title="Travel Buddy"
                            image={TravelBuddy}
                            alt="picture of a travel assistance computer application"
                            github="https://github.com/kmh8827/project1-team2"
                            deploy="https://kmh8827.github.io/project1-team2/"
                            text="Link to Deployed Travel Buddy Application"
                        />
                    </div>

                    <div className="col">
                        <Project
                            title="Dumbbells for Dummies"
                            image={Dumbbells}
                            alt="picture of a workout compantion computer application"
                            github="https://github.com/katemilano/project2"
                            deploy="https://project2-kate.herokuapp.com/"
                            text="Link to a Deployed Dumbbells for Dummies Application"
                        />
                    </div>

                </div>

                <div className="row">
                <div className="col">
                        <Project
                            title="Employee Directory"
                            image={EmployeeDirectory}
                            alt="picture of a sortable list of Randomly Generated Employees"
                            github="https://github.com/kmh8827/EmployeeDirectory"
                            deploy="https://kmh8827.github.io/EmployeeDirectory"
                            text="Link to a deployed Employee Directory application"
                        />
                    </div>

                    <div className="col">
                        <Project
                            title="Weather Dashboard"
                            image={Weather}
                            alt="picture of a weather application that gives forecasts for a city"
                            github="https://github.com/kmh8827/5DayForcast"
                            deploy="https://kmh8827.github.io/5DayForcast"
                            text="Link to Deployed Weather Forecast Application"
                        />
                    </div>
                </div>

                <div className="row">
                <div className="col">
                        <Project
                            title="Offline-Budget Tracker"
                            image={Budget}
                            alt="picture of a budget tracking application"
                            github="https://github.com/kmh8827/OfflineBudgetTracker"
                            deploy="https://hellmanofflinebudgetapp.herokuapp.com/"
                            text="Link to a Deployd Budget Tracking Application"
                        />
                    </div>

                    <div className="col">
                        <Project
                            title="Eat-Da-Burger"
                            image={Burger}
                            alt="picture of a burger-eating Applications"
                            github="https://github.com/kmh8827/Eat-da-burger"
                            deploy="https://hellman-eat-the-burger.herokuapp.com/"
                            text="Link to Deployed Burger Eating Application"
                        />
                    </div>
                </div>
                <br />
                <br />
                <br />
            </main>
        </div>
    );
};

export default Portfolio;